import { AlertTriangle, CheckCircle2, Info, Lightbulb } from "lucide-react";

export const QuickTips = () => {
  const tips = [
    {
      icon: CheckCircle2,
      title: "Verify with NEC 220",
      description: "Always cross-reference calculations with NEC Article 220 for load calculations.",
      type: "success"
    },
    {
      icon: AlertTriangle,
      title: "PF Penalties",
      description: "Power factor below 0.85 may result in utility penalties. Consider PF correction capacitors.",
      type: "warning"
    },
    {
      icon: Info,
      title: "Three-Phase Formula",
      description: "Use √3 (1.732) factor only for line-to-line voltage in 3Φ systems.",
      type: "info"
    },
    {
      icon: Lightbulb,
      title: "Motor Starting Current",
      description: "Induction motors draw 6-8x rated current at startup. Size protection accordingly.",
      type: "tip"
    }
  ];

  const typeStyles = {
    success: "bg-success/10 border-success/30 text-success",
    warning: "bg-warning/10 border-warning/30 text-warning",
    info: "bg-power-reactive/10 border-power-reactive/30 text-power-reactive",
    tip: "bg-accent/10 border-accent/30 text-accent"
  };

  return (
    <div className="space-y-3">
      {tips.map((tip, index) => {
        const Icon = tip.icon;
        const styles = typeStyles[tip.type];

        return (
          <div
            key={index}
            className={`p-3 rounded-lg border ${styles.split(' ').slice(0, 2).join(' ')}`}
          >
            <div className="flex items-start gap-3">
              <Icon className={`h-4 w-4 mt-0.5 shrink-0 ${styles.split(' ')[2]}`} />
              <div>
                <p className="text-sm font-medium text-foreground">
                  {tip.title}
                </p>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {tip.description}
                </p>
              </div>
            </div>
          </div>
        );
      })}

      {/* NEC/CEC Reference */}
      <div className="mt-4 p-3 rounded-lg bg-secondary/50 border border-border">
        <p className="text-xs text-muted-foreground">
          <span className="font-medium text-foreground">Reference Standards:</span>
          <br />
          • NEC (NFPA 70) - USA
          <br />
          • CEC - Canada
          <br />
          • IEC 60364 - International
        </p>
      </div>
    </div>
  );
};
